/* AZYLEEN v4 — Shopify AJAX Cart */
(function(){
'use strict';
function $(i){return document.getElementById(i);}
function fmtPKR(cents){return 'Rs\u00a0'+Math.round(cents/100).toLocaleString();}

/* ── PRELOADER ── */
function dismissPre(){var p=$('az-pre');if(!p||p._g)return;p._g=true;p.classList.add('out');setTimeout(function(){if(p.parentNode)p.parentNode.removeChild(p);},700);}
setTimeout(dismissPre,1500);
window.addEventListener('load',function(){setTimeout(dismissPre,100);});
document.addEventListener('DOMContentLoaded',function(){setTimeout(dismissPre,600);});

/* ── HEADER SCROLL ── */
window.addEventListener('scroll',function(){var h=document.querySelector('.site-header');if(h)h.classList.toggle('scrolled',window.scrollY>60);},{passive:true});

/* ── MOBILE NAV ── */
document.addEventListener('DOMContentLoaded',function(){
  var o=$('mn-open'),n=$('mobile-nav'),v=$('nav-overlay'),c=$('mn-close');
  function open(){if(n)n.classList.add('open');if(v)v.classList.add('show');document.body.style.overflow='hidden';}
  function close(){if(n)n.classList.remove('open');if(v)v.classList.remove('show');document.body.style.overflow='';}
  if(o)o.addEventListener('click',open);
  if(c)c.addEventListener('click',close);
  if(v)v.addEventListener('click',close);
});

/* ── SCROLL REVEAL ── */
document.addEventListener('DOMContentLoaded',function(){
  if(!window.IntersectionObserver)return;
  var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('on');io.unobserve(e.target);}});},{threshold:0.08,rootMargin:'0px 0px -40px 0px'});
  document.querySelectorAll('.rv').forEach(function(el){io.observe(el);});
});

/* ── SHOPIFY AJAX CART ── */
var cartState={items:[],total_price:0,item_count:0};

function fetchCart(cb){
  fetch('/cart.js',{headers:{'Content-Type':'application/json'}})
  .then(function(r){return r.json();})
  .then(function(d){cartState=d;updateCartCount();renderCartDrawer();if(cb)cb(d);})
  .catch(function(e){console.error('Cart fetch:',e);});
}

function updateCartCount(){
  var cnt=cartState.item_count||0;
  document.querySelectorAll('.cart-cnt').forEach(function(el){el.textContent=String(cnt);});
  var hc=$('az-cart-count');
  if(hc)hc.textContent=cnt>0?'('+cnt+' item'+(cnt!==1?'s':'')+')':'';
}

function renderCartDrawer(){
  var wrap=$('az-cart-all');
  if(!wrap)return;
  var items=cartState.items||[];
  var total=cartState.total_price||0;
  var FREE=399900;
  var left=Math.max(0,FREE-total);
  var pct=Math.min(100,(total/FREE)*100);

  if(items.length===0){
    wrap.innerHTML='<div style="flex:1;overflow-y:auto;padding:32px 22px"><div class="cart-empty-state"><span class="cart-empty-icon">\uD83D\uDECD</span><p class="cart-empty-txt">Your bag is empty.<br>Start your glow journey.</p><button class="cart-empty-btn" onclick="window.closeCart()">Explore Products</button></div></div>';
    return;
  }

  var shipMsg=left>0?'Add <b style="color:var(--deep)">'+fmtPKR(left)+'</b> more for free shipping':'<span style="color:var(--green);font-weight:700">\u2713 Free shipping unlocked!</span>';

  var itemsHtml='';
  for(var i=0;i<items.length;i++){
    var item=items[i];
    var imgSrc=item.featured_image&&item.featured_image.url?item.featured_image.url:(item.image||'');
    var imgHtml=imgSrc?'<img class="c-img" src="'+imgSrc+'" alt="'+item.product_title+'" loading="lazy">':'<div class="c-img" style="display:flex;align-items:center;justify-content:center;font-size:22px;background:var(--blush)">\u2728</div>';
    itemsHtml+='<div class="cart-item">'+imgHtml+'<div style="flex:1;min-width:0"><div class="cart-item-name">'+item.product_title+'</div><div class="cart-item-price">'+fmtPKR(item.price)+'</div><div class="cart-item-qty"><button class="qty-btn" onclick="window.cartQty(\''+item.key+'\','+(item.quantity-1)+')">&#8722;</button><span class="qty-num">'+item.quantity+'</span><button class="qty-btn" onclick="window.cartQty(\''+item.key+'\','+(item.quantity+1)+')">+</button><button class="cart-item-remove" onclick="window.cartRemove(\''+item.key+'\')">Remove</button></div></div></div>';
  }

  /* Upsell products — fetches variant ID live via Shopify product API */
  var upsellProducts=[
    {name:'Anua Niacinamide Serum',   price:'Rs\u00a03,649', img:'https://cdn.shopify.com/s/files/1/0714/9568/0111/files/1_3_a8954b97-871a-4abb-818e-72f4d17214c9.webp?v=1775849624', handle:'anua-niacinamide-serum'},
    {name:'COSRX Snail 96 Power Essence', price:'Rs\u00a03,999', img:'https://cdn.shopify.com/s/files/1/0714/9568/0111/files/11-removebg-preview.webp?v=1776070714', handle:'cosrx-snail-96-power-essence'},
    {name:'Celimax Retinal Shot',      price:'Rs\u00a02,380', img:'https://cdn.shopify.com/s/files/1/0714/9568/0111/files/1_4.webp?v=1775917227', handle:'celimax-retinal-shot'},
    {name:'Anua Peach Serum',          price:'Rs\u00a03,899', img:'https://cdn.shopify.com/s/files/1/0714/9568/0111/files/1_3.webp?v=1775672000', handle:'anua-peach-serum'},
    {name:'Mixsoon Bean Serum',        price:'Rs\u00a04,499', img:'https://cdn.shopify.com/s/files/1/0714/9568/0111/files/mixoon_2.webp?v=1776075917', handle:'mixsoon-bean-serum'},
    {name:'Axis-Y Dark Spot Serum',    price:'Rs\u00a03,499', img:'https://cdn.shopify.com/s/files/1/0714/9568/0111/files/10_2.webp?v=1775673864', handle:'axis-y-dark-spot-correcting-serum'}
  ];
  var cartNames=items.map(function(x){return x.product_title;});
  var toShow=upsellProducts.filter(function(p){return cartNames.indexOf(p.name)<0;}).slice(0,2);
  var upsellHtml='';
  if(toShow.length>0){
    upsellHtml='<div class="cart-upsell"><div class="cart-upsell-title">You may also love</div>';
    toShow.forEach(function(p){
      upsellHtml+='<div class="cart-upsell-item">'
        +'<img class="cui-img" src="'+p.img+'" alt="'+p.name+'">'
        +'<div style="flex:1;min-width:0"><div class="cui-name">'+p.name+'</div><div class="cui-price">'+p.price+'</div></div>'
        +'<button class="cui-add" data-handle="'+p.handle+'" data-name="'+p.name+'" onclick="window.upsellAdd(this)">Add +</button>'
        +'</div>';
    });
    upsellHtml+='</div>';
  }

  wrap.innerHTML='<div style="flex:1;overflow-y:auto;padding:14px 22px 4px"><div class="cart-ship-banner"><div class="csb-text">'+shipMsg+'</div><div class="csb-bar-wrap"><div class="csb-bar-fill" style="width:'+pct+'%"></div></div></div>'+upsellHtml+itemsHtml+'</div>'
    +'<div class="cart-sticky-foot"><div class="cart-sub-row"><span class="cart-sub-lbl">Subtotal</span><span class="cart-sub-val">'+fmtPKR(total)+'</span></div>'
    +'<a href="/checkout" class="cart-checkout-btn"><svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2"><rect x="3" y="11" width="18" height="11" rx="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/></svg>Checkout Securely</a>'
    +'<button onclick="window.closeCart()" class="cart-continue-btn">\u2190 Continue Shopping</button></div>';
}

/* ── CART QTY / REMOVE ── */
window.cartQty=function(key,qty){
  fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:key,quantity:qty})})
  .then(function(r){return r.json();}).then(function(d){cartState=d;updateCartCount();renderCartDrawer();}).catch(function(e){console.error(e);});
};
window.cartRemove=function(key){window.cartQty(key,0);};

/* ── ADD TO CART ── */
window.addToCart=function(name,variantId,price){
  if(!variantId||variantId==='0'||variantId===0){showToast('\u26a0\ufe0f Cannot add — variant not found');return;}
  var qty=1;var pqEl=$('page-qty');if(pqEl)qty=parseInt(pqEl.textContent)||1;
  showToast('\uD83D\uDECD Adding to bag...');
  fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:parseInt(variantId),quantity:qty})})
  .then(function(r){if(!r.ok)throw new Error('Add failed');return r.json();})
  .then(function(){showToast('\u2713 Added to bag \u2014 '+name);fetchCart(function(){window.openCart();});})
  .catch(function(e){console.error(e);showToast('\u26a0\ufe0f Could not add. Please try again.');});
};

/* ── UPSELL ADD — fetches variant ID live from Shopify product API ── */
window.upsellAdd=function(btn){
  var handle=btn.getAttribute('data-handle');
  var name=btn.getAttribute('data-name')||'Product';
  if(!handle){showToast('\u26a0\ufe0f Product not found');return;}
  btn.disabled=true;
  btn.textContent='Adding...';
  fetch('/products/'+handle+'.js')
  .then(function(r){if(!r.ok)throw new Error('Not found');return r.json();})
  .then(function(product){
    var variant=product.variants&&product.variants[0];
    if(!variant||!variant.id)throw new Error('No variant');
    if(!variant.available){
      btn.disabled=false;btn.textContent='Add +';
      showToast('\u26a0\ufe0f '+name+' is out of stock');return null;
    }
    return fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:variant.id,quantity:1})});
  })
  .then(function(r){if(!r)return null;if(!r.ok)throw new Error('Add failed');return r.json();})
  .then(function(data){
    if(!data)return;
    btn.textContent='\u2713 Added';
    btn.style.background='var(--green)';
    showToast('\u2713 '+name+' added to bag!');
    fetchCart();
  })
  .catch(function(e){
    console.error('Upsell error:',e);
    btn.disabled=false;btn.textContent='Add +';
    showToast('\u26a0\ufe0f Could not add — try again');
  });
};

/* ── OPEN / CLOSE CART ── */
window.openCart=function(){
  var d=$('az-cart-drawer'),o=$('az-cart-overlay');
  if(d)d.classList.add('open');if(o)o.classList.add('show');
  document.body.style.overflow='hidden';fetchCart();
};
window.closeCart=function(){
  var d=$('az-cart-drawer'),o=$('az-cart-overlay');
  if(d)d.classList.remove('open');if(o)o.classList.remove('show');
  document.body.style.overflow='';
};

/* ── TOAST ── */
window.showToast=function(msg){
  var t=$('az-toast'),m=$('az-toast-msg');
  if(!t||!m)return;
  m.textContent=msg;t.classList.add('show');
  clearTimeout(window._tt);window._tt=setTimeout(function(){t.classList.remove('show');},3000);
};

/* ── COUNTDOWN ── */
document.addEventListener('DOMContentLoaded',function(){
  var cd=$('az-countdown');if(!cd)return;
  var K='az_cd_v4',end=parseInt(localStorage.getItem(K)||'0');
  if(!end||end<Date.now()){end=Date.now()+5*3600000;try{localStorage.setItem(K,end);}catch(e){}}
  var hEl=$('cd-h'),mEl=$('cd-m'),sEl=$('cd-s');
  function tick(){var r=Math.max(0,end-Date.now());if(hEl)hEl.textContent=String(Math.floor(r/3600000)).padStart(2,'0');if(mEl)mEl.textContent=String(Math.floor((r%3600000)/60000)).padStart(2,'0');if(sEl)sEl.textContent=String(Math.floor((r%60000)/1000)).padStart(2,'0');if(r>0)setTimeout(tick,1000);}
  tick();
});

/* ── SOCIAL PROOF POPUP ── */
document.addEventListener('DOMContentLoaded',function(){
  var SP=[
    {n:'Zara A.',c:'Lahore',m:'just bought Anua Niacinamide Serum',bg:'#F4D8D0',i:'ZA',t:'2 min ago'},
    {n:'Sara H.',c:'Karachi',m:'added Centella Suncream to cart',bg:'#EDE9F5',i:'SH',t:'5 min ago'},
    {n:'Mahnoor K.',c:'Islamabad',m:'just bought COSRX Snail Essence',bg:'#D4F0E8',i:'MK',t:'8 min ago'},
    {n:'Amna R.',c:'Rawalpindi',m:'bought Axis-Y Dark Spot Serum',bg:'#F4D8D0',i:'AR',t:'12 min ago'},
    {n:'Hira B.',c:'Faisalabad',m:'bought Celimax Retinal Shot',bg:'#EDE9F5',i:'HB',t:'17 min ago'},
    {n:'Nida M.',c:'Multan',m:'just bought Mixsoon Bean Serum',bg:'#D4F0E8',i:'NM',t:'21 min ago'}
  ];
  var idx=0;
  function show(){
    var pop=$('az-sp-pop'),d=SP[idx%SP.length];idx++;
    var av=$('sp-av'),nm=$('sp-name'),ms=$('sp-msg'),tm=$('sp-time');
    if(!pop)return;
    if(av){av.style.background=d.bg;av.textContent=d.i;}
    if(nm)nm.textContent=d.n+' \u2014 '+d.c;
    if(ms)ms.textContent=d.m;
    if(tm)tm.textContent='\uD83D\uDD50 '+d.t;
    pop.classList.add('show');
    setTimeout(function(){pop.classList.remove('show');},4500);
  }
  var sc=$('az-sp-close');if(sc)sc.addEventListener('click',function(){var p=$('az-sp-pop');if(p)p.classList.remove('show');});
  setTimeout(function(){show();setInterval(show,13000);},6000);
});

/* ── PRODUCT PAGE ── */
window.changePageQty=function(d){var el=$('page-qty');if(el)el.textContent=Math.max(1,(parseInt(el.textContent)||1)+d);};
document.addEventListener('DOMContentLoaded',function(){
  document.querySelectorAll('.prod-thumb').forEach(function(t){
    t.addEventListener('click',function(){
      var src=t.getAttribute('data-src'),img=$('prod-main-img');
      if(img&&src){img.style.opacity='0';setTimeout(function(){img.src=src;img.style.opacity='1';},180);}
      document.querySelectorAll('.prod-thumb').forEach(function(x){x.classList.remove('active');});
      t.classList.add('active');
    });
  });
  var mi=$('prod-main-img');if(mi)mi.style.transition='opacity .18s ease';
  var atc=$('prod-atc');
  if(atc){atc.addEventListener('click',function(){var vid=atc.getAttribute('data-vid'),name=atc.getAttribute('data-name')||'Product';window.addToCart(name,vid,0);});}
});

/* ── FAQ ── */
document.addEventListener('DOMContentLoaded',function(){
  document.querySelectorAll('.faq-q').forEach(function(btn){
    btn.addEventListener('click',function(){
      var item=btn.closest('.faq-item'),ans=item&&item.querySelector('.faq-a'),was=btn.classList.contains('open');
      document.querySelectorAll('.faq-q.open').forEach(function(b){b.classList.remove('open');var a=b.closest('.faq-item')&&b.closest('.faq-item').querySelector('.faq-a');if(a)a.classList.remove('open');});
      if(!was&&ans){btn.classList.add('open');ans.classList.add('open');}
    });
  });
});

/* ── GLOBAL EVENTS ── */
document.addEventListener('DOMContentLoaded',function(){
  document.addEventListener('click',function(e){
    if(e.target.closest('[data-open-cart]'))window.openCart();
    if(e.target.closest('[data-close-cart]'))window.closeCart();
    var atcBtn=e.target.closest('.az-atc');
    if(atcBtn){e.preventDefault();var vid=atcBtn.getAttribute('data-vid'),name=atcBtn.getAttribute('data-name')||'Product';window.addToCart(name,vid,0);}
    var wish=e.target.closest('.pcard-wish');
    if(wish){wish.classList.toggle('active');window.showToast(wish.classList.contains('active')?'\u2665 Saved to wishlist':'Removed from wishlist');}
  });
  var co=$('az-cart-overlay');if(co)co.addEventListener('click',window.closeCart);
  var tc=document.querySelector('.toast-close');if(tc)tc.addEventListener('click',function(){var t=$('az-toast');if(t)t.classList.remove('show');});
  fetchCart();
});

})();
